import { useState } from "react";
import "../../styles/Navbar.css";
import "../../styles/Buttons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../assets/img/Logo.png";
import { useNavigate } from "react-router-dom";

const Navbar = ({ onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => setIsOpen(!isOpen);
  const handleNavigate = (section) => {
    onNavigate(section);
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-md fixed-top shadow-sm">
      <div className="container">
        <a className="navbar-brand" href="/">
          <img src={Logo} alt="Logo" className="nav-logo" />
        </a>

        <button
          className={`d-md-none burger-button ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span className="burger-icon"></span>
          <span className="burger-icon mt-1"></span>
          <span className="burger-icon mt-1"></span>
        </button>

        <div
          className={`collapse navbar-collapse justify-content-between ${
            isOpen ? "show" : ""
          }`}
        >
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <button
                className="nav-link text-white btn btn-link"
                onClick={() => handleNavigate("conocenos")}
              >
                Conócenos
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link text-white btn btn-link"
                onClick={() => handleNavigate("contacto")}
              >
                Contacto
              </button>
            </li>
          </ul>

          <div className="d-flex">
            <button
              className="btn-cta"
              type="button"
              onClick={() => {
                navigate("/login");
              }}
            >
              Armar hamburguesa
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
